// extracted by mini-css-extract-plugin
export default {"pageContainer":"DivisionAlgorithm_pageContainer__4Uem+","moduleContainer":"DivisionAlgorithm_moduleContainer__F8QLO"};